<layout-header-system-buttom *ngIf="sysapi.isWebkitClient"></layout-header-system-buttom>
<ul class="cb-slideshow">
  <li></li>
  <li></li>
  <li></li>
  <li></li>
  <li></li>
  <li></li>
</ul>
 
<div class="container-fluid">
  <div class="row cb-slideshow-text-container ">
    <div class="tm-content   col-sm-8 col-xs-8 ml-auto section">
      <router-outlet></router-outlet>
    </div>
  </div>
   
</div>
 